/**
 * Created by abdulhafeth on 6/28/16.
 */
(function (angular) {

    angular
        .module('harriApp')
        .controller('FarJobModalController', ["$state", "$scope", "modalData", "onAccept", "onDiscard", function ($state, $scope, modalData, onAccept, onDiscard) {
            $scope.city = modalData.city;
            $scope.distance = modalData.distance;

            setTimeout(function () {
                $(".far-job-modal").find('.close')[0].focus();
            }, 500);

            $scope.accept = function(){
                $scope.$hide();
                try{onAccept();}catch(e){}
            };

            $scope.discard = function(){
                $scope.$hide();
                try{onDiscard();}catch(e){}
            };

            $scope.hide = function(){
                $scope.discard();
            };

            if($scope.offLocationChanged){
                $scope.offLocationChanged();
            }

            $scope.offLocationChanged = $scope.$on('$locationChangeStart', function () {
                $scope.$hide();
                $scope.offLocationChanged();
            });
        }]);
})
(angular);
